import { createSlice } from "@reduxjs/toolkit";
import { SetCustomTheme } from "../../functions/helperFunctions";
import { readStoredJson, writeStoredJson } from "../../functions/safeStorage";
import { nativeOwnsAppearance } from "../../functions/appearanceOwner";

// Module scope, and store.js imports this — a raw parse of a corrupt value
// throws before React mounts at all, so there is no error boundary to catch it
const globalStorage = readStoredJson("global", {});
console.log('globalSlice globalStorage: ', globalStorage)

// SCO-2200: only the NEW-chrome apps cede appearance to the native menu —
// the legacy apps also pass platform= but keep the web toggle, so their
// stored useCustomTheme override must keep winning there.
const inApp = nativeOwnsAppearance();

const initialState = {
  darkMode:
    globalStorage && globalStorage.useCustomTheme && !inApp
      ? globalStorage.customTheme
      : false,
  urlParams: {},
  hideNavbar: false,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setGlobal(state, action) {
      console.log("set globalSlice action: ", action);
      const globalStorage = readStoredJson("global", {});
      console.log("set globalSlice globalStorage: ", globalStorage);
      //globalStorage.customTheme is true for dark, false for light
      const { darkMode, urlParams } = action.payload;

      if (globalStorage.useCustomTheme && !inApp) {
        SetCustomTheme("none", globalStorage.customTheme ? "dark" : "light");
      } else if (!inApp) {
        SetCustomTheme("none", "auto");
      }

      state.darkMode =
        globalStorage.useCustomTheme && !inApp
          ? globalStorage.customTheme
          : darkMode || darkMode === null
            ? darkMode
            : false;

      console.log("urlParams ? urlParams : state.urlParams: ", urlParams);

      const getParamsObject = () => {
        const params = new URLSearchParams(window.location.search);
        const paramsObject = {};
        for (const [key, value] of params.entries()) {
          paramsObject[key] = value;
        }
        return paramsObject;
      };

      state.urlParams =
        urlParams && urlParams.size > 0 ? urlParams : state.urlParams;

      console.log("globalSlice state urlParams: ", state.urlParams.size);
      console.log("globalSlice state darkMode: ", state.darkMode);

      const newGlobal = { ...globalStorage, ...state };

      console.log("newGlobal localStorage: ", newGlobal);

      writeStoredJson("global", { ...globalStorage, ...state });
    },
    clearGlobal: () => initialState,
    setNavbarVisibility(state, action) {
      state.hideNavbar = action.payload;
    },
  },
});

export const { setGlobal, clearGlobal, setNavbarVisibility } =
  globalSlice.actions;

export default globalSlice.reducer;
